import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { EstablishmentProductPriceTableItem } from "../../types/establishmentProducts.type";
import { dateTimeTransformer } from "@/common/utils/dateTransformer";
import { UserRoundIcon } from "lucide-react";

type UpdatedAtProductPriceProps = {
  data: EstablishmentProductPriceTableItem;
};

const UpdatedAtProductPrice = ({ data: price }: UpdatedAtProductPriceProps) => {
  return (
    <div className="flex items-center gap-2 cursor-default">
      <ImageWithPlaceholder
        url={price.last_updated_by?.profile_picture?.url}
        alt={price.last_updated_by?.full_name}
        className="size-6"
        iconClassName="size-4"
        placeholderIcon={UserRoundIcon}
      />

      <div className="flex flex-col gap-1">
        <p className="underline">{price.last_updated_by?.full_name}</p>
        <p>{dateTimeTransformer(new Date(price.updated_at))}</p>
      </div>
    </div>
  );
};

export default UpdatedAtProductPrice;
